import React, { useState } from "react";
import PropTypes from "prop-types";

import { Row, Col, Collapse, Well } from "react-bootstrap";
import { IoFunnel } from "react-icons/io5";

import HeaderWrapper from "../common/HeaderWrapper";
import RequestNatureSelect from "../common/RequestNatureSelect";
import CustomerSelect from "../common/CustomerSelect";
import CreatableSelect from "../common/CreatableSelect";

export default function ProjectKeywordsFilters({
  isMobile,
  filters,
  onChange,
  loading,
  onReset,
  onFilter
}) {
  const [openFilters, setOpenFilters] = useState(true);
  return (
    <React.Fragment>
      <HeaderWrapper
        breadcrumbs={[{ label: "Project Keywords" }]}
        onClickAction={[
          { action: () => setOpenFilters(!openFilters), icon: <IoFunnel /> }
        ]}
        isMobile={isMobile}
      />
      <Collapse
        in={openFilters}
        className="filter-container"
        style={{ paddingLeft: 0 }}
      >
        <div>
          <Well>
            <Row style={{ marginBottom: 15 }}>
              <Col md={4}>
                <CustomerSelect
                  isMulti
                  label=""
                  placeholder="Customer"
                  value={filters.customer || []}
                  onChange={(e) => onChange("customer", e || [])}
                />
              </Col>
              <Col md={4}>
                <RequestNatureSelect
                  label=""
                  name="request_nature"
                  placeholder="Request Nature"
                  value={filters.request_nature}
                  onChange={onChange}
                />
              </Col>
              <Col md={4}>
                <CreatableSelect
                  label=""
                  name="keywords"
                  placeholder="Keywords"
                  value={filters.keywords}
                  onChange={onChange}
                  formatCreateLabel="Type a keyword and press enter"
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <button
                  className="btn btn-warning"
                  type="button"
                  onClick={onReset}
                  disabled={loading}
                >
                  Reset
                </button>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={onFilter}
                  disabled={loading}
                >
                  Fetch Data
                </button>
              </Col>
            </Row>
          </Well>
        </div>
      </Collapse>
    </React.Fragment>
  );
}

ProjectKeywordsFilters.propTypes = {
  isMobile: PropTypes.bool,
  filters: PropTypes.object,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  onReset: PropTypes.func,
  onFilter: PropTypes.func
};

ProjectKeywordsFilters.defaultProps = {
  filters: {}
};
